export const getFirstDayOfTheMonth = (date: Date) =>
  date && new Date(date.getFullYear(), date.getMonth());

export const getDateRangeByStartYear = (startYear: number) => {
  return Array.from(
    Array(new Date().getFullYear() - startYear + 1),
    (_, i) => startYear + i,
  );
};
